module.exports = __webpack_public_path__ + "static/media/icon_care.282a73b5.svg";